import { fromJS, Map } from 'immutable';
import get from 'lodash/get';

import * as PaymentsConstants from '../constants';
import * as D from '../deps';
import * as PaymentsUtils from '../utils';

const INITIAL_STATE = Map({
  [PaymentsConstants.ReducerKeys.PREVIOUS_PLAN]: Map(),
  [PaymentsConstants.ReducerKeys.SWITCHING_PLANS]: false,
  [PaymentsConstants.ReducerKeys.PAYPAL_REDIRECT_URL]: '',
  [PaymentsConstants.ReducerKeys.PAYPAL_STATUS]: '',
  [PaymentsConstants.ReducerKeys.IS_PENDING_PAYMENT_UPDATE]: false,
  [PaymentsConstants.ReducerKeys.UPDATING_BILLING_INFO]: false,
  [PaymentsConstants.ReducerKeys.UPDATED_BILLING_INFO]: false,
  [PaymentsConstants.ReducerKeys.CREDIT_CARD_INFO]: Map(),
  [PaymentsConstants.ReducerKeys.CREDIT_CARD_INFO_IS_LOADED]: false,
  [PaymentsConstants.ReducerKeys.SUBSCRIPTION_INFO]: null,
  [PaymentsConstants.ReducerKeys.SUBSCRIPTION_INFO_V2]: Map(),
  [PaymentsConstants.ReducerKeys.AVAILABLE_PRODUCTS]: null,
  [PaymentsConstants.ReducerKeys.SELECTED_PAYMENT_PROVIDER]:
    PaymentsConstants.PaymentProviders.CREDIT_CARD,
  [PaymentsConstants.ReducerKeys.CREDIT_CARD_FORM_STATUS]: '',
  [PaymentsConstants.ReducerKeys.SERVER_ERROR_TYPE]: '',
  [PaymentsConstants.ReducerKeys.SERVER_ERROR_MESSAGE]: '',
  [PaymentsConstants.ReducerKeys.IS_PENDING_PURCHASE]: false,
  [PaymentsConstants.ReducerKeys.PAYPAL_COMPLETE]: false,
  [PaymentsConstants.ProductKeys.FAMILY_PLAN_RECORD]: null,
  [PaymentsConstants.SubscriptionKeys.IS_MANAGING_FAMILY_PLAN_ACCOUNTS]: false,
  [PaymentsConstants.SubscriptionKeys.IS_INVITING_FAMILY_PLAN_ACCOUNTS]: false,
  [PaymentsConstants.ReducerKeys.MOBILE_MESSAGE]: '',
  [PaymentsConstants.ReducerKeys.FAMILY_PLAN_PARENT_EMAIL]: '',
});

export default D.createReducer(INITIAL_STATE, {
  [D.Constants.Api.ApiActions.GET_CREDIT_CARD_V2_SUCCESS]: getCreditCardSuccess,
  [PaymentsConstants.Actions.IS_PENDING_PAYMENT_UPDATE]: startUpdatingPaymentInfo,
  [PaymentsConstants.Actions.UPDATING_BILLING_INFO]: updatingBillingInfo,
  [PaymentsConstants.Actions.STOP_UPDATING_BILLING_INFO]: stopUpdatingBillingInfo,
  [PaymentsConstants.Actions.RESET_UPDATED_BILLING_INFO]: resetUpdatedBillingInfo,
  [PaymentsConstants.Actions.SELECT_PAYMENT_PROVIDER]: onSelectPaymentProvider,
  [PaymentsConstants.Actions.CLEAR_SELECTED_OFFER]: onClearSelectedOffer,
  [D.Constants.Api.ApiActions.PREPARE_TO_ACQUIRE_PAYPAL_PRODUCT_SUCCESS]: startPaypalRedeemSuccess,
  [D.Constants.Api.ApiActions.PREPARE_TO_ACQUIRE_PAYPAL_PRODUCT_FAIL]: startPaypalRedeemFailure,
  [PaymentsConstants.Actions.RESET_PAYPAL_STATUS]: resetPaypalStatus,
  [PaymentsConstants.Actions.RESET_INVALID_CREDIT_CARD_STATUS]: resetInvalidCreditCardStatus,
  [D.Constants.Api.ApiActions.UPDATE_BILLING_INFO_V2_FAIL]: updateBillingInfoFail,
  [PaymentsConstants.Actions.CREDIT_CARD_FORM_RESET]: creditCardFormReset,
  [PaymentsConstants.Actions.IS_ANONYMOUS_UPGRADE]: isAnonymousUpgrade,
  [PaymentsConstants.Actions.UPGRADE_OFFERED]: upgradeOffered,
  [PaymentsConstants.Actions.TOGGLE_SWITCHING_PLANS]: toggleSwitchingPlans,
  [D.Constants.Api.ApiActions.GET_AVAILABLE_PRODUCTS_SUCCESS]: getAvailableProductsSuccess,
  [D.Constants.Api.ApiActions.ACQUIRE_PRODUCT_SUCCESS]: acquireProductSuccess,
  [D.Constants.Api.ApiActions.ACQUIRE_PRODUCT_ATTEMPT]: acquireProductAttempt,
  [D.Constants.Api.ApiActions.GET_SUBSCRIPTION_INFO_V2_SUCCESS]: getSubscriptionInfoV2Success,
  [D.Constants.Api.ApiActions.UPDATE_BILLING_INFO_V2_SUCCESS]: updateBillingInfoSuccess,
  [D.Constants.Api.ApiActions.ACQUIRE_PRODUCT_FAIL]: acquireProductFail,
  [PaymentsConstants.Actions.ACQUIRE_OFFER]: isPendingPurchase,
  [PaymentsConstants.Actions.FINISH_ACQUIRE_PRODUCT]: hasFinishedPurchase,
  [PaymentsConstants.Actions.UPDATE_CREDIT_CARD_INFO]: startUpdatingPaymentInfo,
  [D.Constants.Api.ApiActions.FAMILY_PLAN_GET_RECORD_SUCCESS]: onGetFamilyPlanRecord,
  [PaymentsConstants.Actions.START_MANAGING_FAMILY_PLAN_ACCOUNTS]:
    onStartManagingFamilyPlanAccounts,
  [PaymentsConstants.Actions.STOP_MANAGING_FAMILY_PLAN_ACCOUNTS]: onStopManagingFamilyPlanAccounts,
  [PaymentsConstants.Actions.DISPLAY_MOBILE_MESSAGE]: onDisplayMobileMessage,
  [PaymentsConstants.Actions.CLEAR_MOBILE_MESSAGE]: onClearMobileMessage,
  [PaymentsConstants.Actions.SET_PAYPAL_COMPLETE]: onSetPaypalComplete,
  [D.Constants.Api.ApiActions.FAMILY_PLAN_ACCEPT_INVITE_SUCCESS]: onAcceptFamilyPlanInviteSuccess,
  [D.Constants.Api.ApiActions.FAMILY_PLAN_GET_PARENT_INFO_SUCCESS]:
    onGetFamilyPlanParentInfoSuccess,
});

// TODO: WEBCLIENT-3560 – watcher is not firing getCreditCardV2Success action, figure out why later
function getCreditCardSuccess(state, action) {
  return state.merge({
    [PaymentsConstants.ReducerKeys.CREDIT_CARD_INFO]: action.response,
    [PaymentsConstants.ReducerKeys.CREDIT_CARD_INFO_IS_LOADED]: true,
  });
}

function updateBillingInfoSuccess(state, action) {
  if (action.params.content.deleteCreditCard) {
    return state.merge({
      [PaymentsConstants.ReducerKeys.UPDATED_BILLING_INFO]: true,
      [PaymentsConstants.ReducerKeys.UPDATING_BILLING_INFO]: false,
      [PaymentsConstants.ReducerKeys.CREDIT_CARD_FORM_STATUS]:
        PaymentsConstants.DELETED_CREDIT_CARD,
      [PaymentsConstants.ReducerKeys.SERVER_ERROR_TYPE]: '',
      [PaymentsConstants.ReducerKeys.SERVER_ERROR_MESSAGE]: '',
      [PaymentsConstants.ReducerKeys.INVALID_CREDIT_CARD]: false,
      [PaymentsConstants.ReducerKeys.IS_PENDING_PAYMENT_UPDATE]: false,
    });
  }
  return state.merge({
    [PaymentsConstants.ReducerKeys.UPDATED_BILLING_INFO]: true,
    [PaymentsConstants.ReducerKeys.UPDATING_BILLING_INFO]: false,
    [PaymentsConstants.ReducerKeys.CREDIT_CARD_FORM_STATUS]: PaymentsConstants.CREDIT_CARD_SUCCESS,
    [PaymentsConstants.ReducerKeys.SERVER_ERROR_TYPE]: '',
    [PaymentsConstants.ReducerKeys.SERVER_ERROR_MESSAGE]: '',
    [PaymentsConstants.ReducerKeys.INVALID_CREDIT_CARD]: false,
    [PaymentsConstants.ReducerKeys.IS_PENDING_PAYMENT_UPDATE]: false,
  });
}

// misleading: this is just used to check if the *payment form* is open, not if an action to update billing as been fired
function updatingBillingInfo(state) {
  return state.set(PaymentsConstants.ReducerKeys.UPDATING_BILLING_INFO, true);
}

function stopUpdatingBillingInfo(state) {
  return state.set(PaymentsConstants.ReducerKeys.UPDATING_BILLING_INFO, false);
}

function resetUpdatedBillingInfo(state) {
  return state.merge({
    [PaymentsConstants.ReducerKeys.CREDIT_CARD_FORM_STATUS]: '',
    [PaymentsConstants.ReducerKeys.SERVER_ERROR_TYPE]: '',
    [PaymentsConstants.ReducerKeys.SERVER_ERROR_MESSAGE]: '',
    [PaymentsConstants.ReducerKeys.UPDATED_BILLING_INFO]: false,
  });
}

// this is a loading state for when someone clicks actually updates their payment info
function startUpdatingPaymentInfo(state) {
  return state.set(PaymentsConstants.ReducerKeys.IS_PENDING_PAYMENT_UPDATE, true);
}

function onSelectPaymentProvider(state, action) {
  const paymentProvider = get(action, 'data.paymentProvider');

  if (!paymentProvider) {
    return;
  }

  return state.set(PaymentsConstants.ReducerKeys.SELECTED_PAYMENT_PROVIDER, paymentProvider);
}

function onClearSelectedOffer(state) {
  return state.merge({
    [PaymentsConstants.ReducerKeys.SELECTED_PAYMENT_PROVIDER]:
      PaymentsConstants.PaymentProviders.CREDIT_CARD,
  });
}

function startPaypalRedeemSuccess(state, action) {
  return state.merge({
    [PaymentsConstants.ReducerKeys.PAYPAL_REDIRECT_URL]: action.response.redirectUrl,
    [PaymentsConstants.ReducerKeys.IS_PENDING_PAYMENT_UPDATE]: true,
  });
}

function startPaypalRedeemFailure(state) {
  return state.set(PaymentsConstants.ReducerKeys.IS_PENDING_PURCHASE, false);
}

function resetPaypalStatus(state) {
  return state.set(PaymentsConstants.ReducerKeys.PAYPAL_STATUS, '');
}

function acquireProductFail(state, action) {
  const maybeInvalidCard =
    action.error.errorType === PaymentsConstants.ErrorCodes.CREDIT_CARD_DECLINED_PAYMENT ||
    action.error.errorType === PaymentsConstants.ErrorCodes.CREDIT_CARD_DECLINED_AUTHORIZATION ||
    action.error.errorType === PaymentsConstants.ErrorCodes.SUBSCRIPTION_SERVICE_EXCEPTION;

  if (maybeInvalidCard) {
    const { errorType, errorMessage } = PaymentsUtils.parseErrorTypeAndMessage(action.error);
    return state.merge({
      [PaymentsConstants.ReducerKeys.CREDIT_CARD_FORM_STATUS]: action.error.errorType,
      [PaymentsConstants.ReducerKeys.IS_PENDING_PURCHASE]: false,
      [PaymentsConstants.ReducerKeys.PAYPAL_COMPLETE]: true,
      [PaymentsConstants.ReducerKeys.INVALID_CREDIT_CARD]: true,
      [PaymentsConstants.ReducerKeys.SERVER_ERROR_TYPE]: errorType,
      [PaymentsConstants.ReducerKeys.SERVER_ERROR_MESSAGE]: errorMessage,
    });
  }
  return state.merge({
    [PaymentsConstants.ReducerKeys.CREDIT_CARD_FORM_STATUS]: action.error.errorType,
    [PaymentsConstants.ReducerKeys.IS_PENDING_PURCHASE]: false,
    [PaymentsConstants.ReducerKeys.PAYPAL_COMPLETE]: true,
  });
}

function onSetPaypalComplete(state) {
  return state.set(PaymentsConstants.ReducerKeys.PAYPAL_COMPLETE, true);
}

function resetInvalidCreditCardStatus(state) {
  return state.set(PaymentsConstants.ReducerKeys.INVALID_CREDIT_CARD, false);
}

function updateBillingInfoFail(state, action) {
  const content = get(action, 'error.action.content', {});
  if (content.deleteCreditCard || content.cancelSubscription) {
    return state.set(PaymentsConstants.ReducerKeys.IS_PENDING_PAYMENT_UPDATE, false);
  }

  const { errorType, errorMessage } = PaymentsUtils.parseErrorTypeAndMessage(action.error);
  return state.merge({
    [PaymentsConstants.ReducerKeys.CREDIT_CARD_FORM_STATUS]: action.error.errorType,
    [PaymentsConstants.ReducerKeys.IS_PENDING_PAYMENT_UPDATE]: false,
    [PaymentsConstants.ReducerKeys.SERVER_ERROR_TYPE]: errorType,
    [PaymentsConstants.ReducerKeys.SERVER_ERROR_MESSAGE]: errorMessage,
  });
}

// used to clear any status/error messages
function creditCardFormReset(state) {
  return state.set(PaymentsConstants.ReducerKeys.CREDIT_CARD_FORM_STATUS, '');
}

function isAnonymousUpgrade(state) {
  return state.set(PaymentsConstants.ReducerKeys.IS_ANONYMOUS_UPGRADE, true);
}

function toggleSwitchingPlans(state, action) {
  return state.set(PaymentsConstants.ReducerKeys.SWITCHING_PLANS, action.isSwitchingPlans);
}

function getAvailableProductsSuccess(state, action) {
  return state.set(
    PaymentsConstants.ReducerKeys.AVAILABLE_PRODUCTS,
    fromJS(action.response.productGroups),
  );
}

function getSubscriptionInfoV2Success(state, action) {
  const response = action.response;
  const paymentProvider = response.paymentProvider;
  const newState = {
    [PaymentsConstants.ReducerKeys.SUBSCRIPTION_INFO_V2]: response,
  };

  if (
    [
      PaymentsConstants.PaymentProviders.PAYPAL,
      PaymentsConstants.PaymentProviders.CREDIT_CARD,
    ].includes(paymentProvider)
  ) {
    newState[PaymentsConstants.ReducerKeys.SELECTED_PAYMENT_PROVIDER] = paymentProvider;
  }

  return state.merge(newState);
}

function isPendingPurchase(state) {
  return state.set(PaymentsConstants.ReducerKeys.IS_PENDING_PURCHASE, true);
}

function hasFinishedPurchase(state) {
  return state.merge({
    [PaymentsConstants.ReducerKeys.IS_PENDING_PURCHASE]:
      INITIAL_STATE[PaymentsConstants.ReducerKeys.IS_PENDING_PURCHASE],
    [PaymentsConstants.ReducerKeys.PREVIOUS_PLAN]:
      INITIAL_STATE[PaymentsConstants.ReducerKeys.PREVIOUS_PLAN],
  });
}

function acquireProductSuccess(state, action) {
  const { paymentProvider } = get(action, 'params.content');

  const { previousTier, previousDiscountType } = get(action, 'params.actionParams');

  const previousPlan = {
    [PaymentsConstants.PlanKeys.TIER]: previousTier,
    [PaymentsConstants.PlanKeys.DISCOUNT_TYPE]: previousDiscountType,
  };

  const newState = {
    [PaymentsConstants.ReducerKeys.PREVIOUS_PLAN]: previousPlan,
    [PaymentsConstants.ReducerKeys.PAYPAL_COMPLETE]:
      paymentProvider === PaymentsConstants.PaymentProviders.PAYPAL,
    [PaymentsConstants.ReducerKeys.CREDIT_CARD_FORM_STATUS]:
      paymentProvider === PaymentsConstants.PaymentProviders.CREDIT_CARD
        ? PaymentsConstants.CREDIT_CARD_SUCCESS
        : INITIAL_STATE[PaymentsConstants.ReducerKeys.CREDIT_CARD_FORM_STATUS],
  };

  return state.merge(newState);
}

function acquireProductAttempt(state) {
  return state.set(PaymentsConstants.ReducerKeys.INVALID_CREDIT_CARD, false);
}

function upgradeOffered(state, action) {
  const { sourceId, sourceType } = action.data;
  return state.merge({
    sourceId,
    sourceType,
  });
}

function onGetFamilyPlanRecord(state, action) {
  return state.set(PaymentsConstants.ProductKeys.FAMILY_PLAN_RECORD, fromJS(action.response));
}

// onStartManagingFamilyPlanAccounts & onStopManagingFamilyPlanAccounts manage only UI states
function onStartManagingFamilyPlanAccounts(state, action) {
  return state.merge({
    [PaymentsConstants.SubscriptionKeys.IS_MANAGING_FAMILY_PLAN_ACCOUNTS]: action.isManaging,
    [PaymentsConstants.SubscriptionKeys.IS_INVITING_FAMILY_PLAN_ACCOUNTS]: action.isInviting,
  });
}

function onStopManagingFamilyPlanAccounts(state) {
  return state.merge({
    [PaymentsConstants.SubscriptionKeys.IS_MANAGING_FAMILY_PLAN_ACCOUNTS]: false,
    [PaymentsConstants.SubscriptionKeys.IS_INVITING_FAMILY_PLAN_ACCOUNTS]: false,
  });
}

function onDisplayMobileMessage(state, action) {
  const message = get(action.data, 'message');
  return state.set(PaymentsConstants.ReducerKeys.MOBILE_MESSAGE, message);
}

function onClearMobileMessage(state) {
  return state.set(PaymentsConstants.ReducerKeys.MOBILE_MESSAGE, '');
}

function onAcceptFamilyPlanInviteSuccess(state, action) {
  return state.set(
    PaymentsConstants.ReducerKeys.FAMILY_PLAN_PARENT_EMAIL,
    get(action, 'response.parentEmail'),
  );
}

function onGetFamilyPlanParentInfoSuccess(state, action) {
  return state.set(
    PaymentsConstants.ReducerKeys.FAMILY_PLAN_PARENT_EMAIL,
    get(action, 'response.parentEmail'),
  );
}
